import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import type { Payable } from '../../../../../models/entities/payable';
import type { DownloadCheckDialogResult } from './download-check-dialog.component';

@Injectable({ providedIn: 'root' })
export class DownloadCheckDialogStateService
{
    readonly open = signal(false);
    readonly payable = signal<Payable | null>(null);

    private _result$: Subject<DownloadCheckDialogResult | null> | null = null;

    ask(payable: Payable): Observable<DownloadCheckDialogResult | null> {
        this.answer(null);
        this._result$ = new Subject<DownloadCheckDialogResult | null>();
        this.payable.set(payable);
        this.open.set(true);

        return this._result$.asObservable();
    }

    answer(result: DownloadCheckDialogResult | null): void {
        const result$ = this._result$;
        this._result$ = null;
        this.open.set(false);
        result$?.next(result);
        result$?.complete();
    }
}
